import {DateTime} from 'luxon';
import {isFirebaseTimestamp} from "./types_check";

export function toDateTime(secs) {
    var t = new Date(1970, 0, 1); // Epoch
    t.setSeconds(secs);
    return t;
}


export function unixToDateString(unix) {
    const date = new Date(unix * 1000);
    return (
        `${date.getDate()} / ${date.getMonth() + 1} / ${date.getFullYear()}`
    );
}

export function epochToDate(epoch) {

    return isFirebaseTimestamp(epoch) ? DateTime.fromJSDate(epoch.toDate()).toFormat('dd MMM yyyy') : '--/--/---';

}

export function epochToTime(epoch) {
    return DateTime.fromJSDate(epoch.toDate()).toFormat('HH:mm')
}

export function epochToDateTime(epoch) {
    return isFirebaseTimestamp(epoch) ? DateTime.fromJSDate(epoch.toDate()).toFormat('dd MMM yyyy HH:mm') : '--/--/---';
}